// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* new */

.SafetyGrid-userAppBgWrapper-b4e_j {
    background-position: center;
    background-size: cover;
    padding: 35px 108px;
    background-color: var(--common-gray-bg);
    border-radius: 0 24px 0 24px;
}

.SafetyGrid-userAppRowGrid-r0APi {
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    display: grid;
    grid-template-columns: 350px 1fr;
    gap: 20px;
}

.SafetyGrid-userAppHeading-bJ6GN {
    font-size: 36px;
    line-height: 46px;
    font-weight: 700;
    color: var(--common-primary-foreground);
    margin: 0 0 18px;
}

.SafetyGrid-userAppDesc-p132A {
    font-size: 18px;
    line-height: 28px;
    font-weight: 500;
    color: var(--common-primary-foreground);
    margin: 0 0 30px;
}

.SafetyGrid-userAppBtnGroup-KdFaw {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: start;
        -ms-flex-pack: start;
            justify-content: flex-start;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    gap: 12px;
}

.SafetyGrid-userAppBtnLink-jY8v5 {
    max-width: 168px;
    width: 100%;
    display: inline-block;
}

.SafetyGrid-userAppBtnLink-jY8v5 img {
    width: 100%;
    height: 100%;
}

.SafetyGrid-userAppImageWrapper-I7WFh {
    max-width: 300px;
    height: 470px;
    margin-right: auto;
}

.SafetyGrid-userAppImageWrapper-I7WFh>img {
    width: 100%;
    height: 100%;
    -o-object-fit: contain;
       object-fit: contain;
}

.SafetyGrid-noPopularLocationTop-MdAZC {
    margin-top: 42px;
}

@media (min-width:1200px) {
    .SafetyGrid-userAppRowGrid-r0APi {
        grid-template-columns: 400px 1fr;
    }
}

@media (max-width:991px) {
    .SafetyGrid-userAppBgWrapper-b4e_j {
        padding: 35px 30px;
    }

    .SafetyGrid-userAppImageWrapper-I7WFh {
        margin: auto;
    }
}

@media (max-width:767px) {
    .SafetyGrid-userAppBgWrapper-b4e_j {
        padding: 35px 15px;
    }

    .SafetyGrid-userAppRowGrid-r0APi {
        grid-template-columns: 100%;
    }

    .SafetyGrid-userAppImageWrapper-I7WFh {
        height: 370px;
    }

    .SafetyGrid-userAppHeading-bJ6GN {
        font-size: 24px;
        line-height: 32px;
        margin: 0 0 16px;
    }

    .SafetyGrid-userAppDesc-p132A {
        font-size: 16px;
        line-height: 24px;
        margin: 0 0 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Home/SafetyGrid/SafetyGrid.css"],"names":[],"mappings":"AAAA,QAAQ;;AAER;IACI,2BAA2B;IAC3B,sBAAsB;IACtB,mBAAmB;IACnB,uCAAuC;IACvC,4BAA4B;AAChC;;AAEA;IACI,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,uBAA2B;QAA3B,oBAA2B;YAA3B,2BAA2B;IAC3B,mBAAe;QAAf,eAAe;IACf,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAmB;OAAnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;IACpB;AACJ","sourcesContent":["/* new */\n\n.userAppBgWrapper {\n    background-position: center;\n    background-size: cover;\n    padding: 35px 108px;\n    background-color: var(--common-gray-bg);\n    border-radius: 0 24px 0 24px;\n}\n\n.userAppRowGrid {\n    align-items: center;\n    display: grid;\n    grid-template-columns: 350px 1fr;\n    gap: 20px;\n}\n\n.userAppHeading {\n    font-size: 36px;\n    line-height: 46px;\n    font-weight: 700;\n    color: var(--common-primary-foreground);\n    margin: 0 0 18px;\n}\n\n.userAppDesc {\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 500;\n    color: var(--common-primary-foreground);\n    margin: 0 0 30px;\n}\n\n.userAppBtnGroup {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    gap: 12px;\n}\n\n.userAppBtnLink {\n    max-width: 168px;\n    width: 100%;\n    display: inline-block;\n}\n\n.userAppBtnLink img {\n    width: 100%;\n    height: 100%;\n}\n\n.userAppImageWrapper {\n    max-width: 300px;\n    height: 470px;\n    margin-right: auto;\n}\n\n.userAppImageWrapper>img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n.noPopularLocationTop {\n    margin-top: 42px;\n}\n\n@media (min-width:1200px) {\n    .userAppRowGrid {\n        grid-template-columns: 400px 1fr;\n    }\n}\n\n@media (max-width:991px) {\n    .userAppBgWrapper {\n        padding: 35px 30px;\n    }\n\n    .userAppImageWrapper {\n        margin: auto;\n    }\n}\n\n@media (max-width:767px) {\n    .userAppBgWrapper {\n        padding: 35px 15px;\n    }\n\n    .userAppRowGrid {\n        grid-template-columns: 100%;\n    }\n\n    .userAppImageWrapper {\n        height: 370px;\n    }\n\n    .userAppHeading {\n        font-size: 24px;\n        line-height: 32px;\n        margin: 0 0 16px;\n    }\n\n    .userAppDesc {\n        font-size: 16px;\n        line-height: 24px;\n        margin: 0 0 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userAppBgWrapper": `SafetyGrid-userAppBgWrapper-b4e_j`,
	"userAppRowGrid": `SafetyGrid-userAppRowGrid-r0APi`,
	"userAppHeading": `SafetyGrid-userAppHeading-bJ6GN`,
	"userAppDesc": `SafetyGrid-userAppDesc-p132A`,
	"userAppBtnGroup": `SafetyGrid-userAppBtnGroup-KdFaw`,
	"userAppBtnLink": `SafetyGrid-userAppBtnLink-jY8v5`,
	"userAppImageWrapper": `SafetyGrid-userAppImageWrapper-I7WFh`,
	"noPopularLocationTop": `SafetyGrid-noPopularLocationTop-MdAZC`
};
module.exports = ___CSS_LOADER_EXPORT___;
